// Data scraped from https://help.adjust.com/en/article/countries-by-region
// Query: [...document.querySelectorAll("#article-main > div.thc_table > div > div > div > table > tbody > tr")].reduce((acc, row) => ({ ...acc, [row.querySelector("td:nth-child(3)").innerText]: [...(acc[[row.querySelector("td:nth-child(3)").innerText]]??[]), row.querySelector("td:nth-child(1)").innerText] }) , {})
// Might be hard to maintain, but all the libraries I found had pretty terrible TS support or were not trustworthy.
const regionPerCountry = {
  ad: "emea",
  ae: "emea",
  af: "emea",
  ag: "latam",
  ai: "latam",
  al: "emea",
  am: "emea",
  ao: "emea",
  aq: "emea",
  ar: "latam",
  as: "apac",
  at: "emea",
  au: "apac",
  aw: "latam",
  ax: "emea",
  az: "emea",
  ba: "emea",
  bb: "latam",
  bd: "apac",
  be: "emea",
  bf: "emea",
  bg: "emea",
  bh: "emea",
  bi: "emea",
  bj: "emea",
  bl: "emea",
  bm: "latam",
  bn: "apac",
  bo: "latam",
  br: "latam",
  bs: "latam",
  bt: "apac",
  bv: "emea",
  bw: "emea",
  by: "emea",
  bz: "latam",
  ca: "na",
  cc: "apac",
  cd: "emea",
  cf: "emea",
  cg: "emea",
  ch: "emea",
  ci: "emea",
  ck: "emea",
  cl: "latam",
  cm: "emea",
  cn: "apac",
  co: "latam",
  cr: "latam",
  cu: "latam",
  cv: "emea",
  cw: "emea",
  cx: "apac",
  cy: "emea",
  cz: "emea",
  de: "emea",
  dj: "emea",
  dk: "emea",
  dm: "latam",
  do: "latam",
  dz: "emea",
  ec: "latam",
  ee: "emea",
  eg: "emea",
  eh: "emea",
  er: "emea",
  es: "emea",
  et: "emea",
  fi: "emea",
  fj: "apac",
  fk: "latam",
  fm: "apac",
  fo: "emea",
  fr: "emea",
  ga: "emea",
  gb: "emea",
  gd: "latam",
  ge: "emea",
  gf: "emea",
  gg: "emea",
  gh: "emea",
  gi: "emea",
  gl: "emea",
  gm: "emea",
  gn: "emea",
  gp: "emea",
  gq: "emea",
  gr: "emea",
  gs: "latam",
  gt: "latam",
  gu: "apac",
  gw: "emea",
  gy: "latam",
  hk: "apac",
  hm: "emea",
  hn: "latam",
  hr: "emea",
  ht: "latam",
  hu: "emea",
  id: "apac",
  ie: "emea",
  il: "emea",
  im: "emea",
  in: "apac",
  io: "apac",
  iq: "emea",
  ir: "emea",
  is: "emea",
  it: "emea",
  je: "emea",
  jm: "latam",
  jo: "emea",
  jp: "apac",
  ke: "emea",
  kg: "emea",
  kh: "apac",
  ki: "apac",
  km: "emea",
  kn: "latam",
  kp: "apac",
  kr: "apac",
  kw: "emea",
  ky: "latam",
  kz: "emea",
  la: "apac",
  lb: "emea",
  lc: "latam",
  li: "emea",
  lk: "apac",
  lr: "emea",
  ls: "emea",
  lt: "emea",
  lu: "emea",
  lv: "emea",
  ly: "emea",
  ma: "emea",
  mc: "emea",
  md: "emea",
  me: "emea",
  mf: "emea",
  mg: "emea",
  mh: "apac",
  mk: "emea",
  ml: "emea",
  mm: "apac",
  mn: "apac",
  mo: "apac",
  mp: "apac",
  mq: "emea",
  mr: "emea",
  ms: "latam",
  mt: "emea",
  mu: "emea",
  mv: "apac",
  mw: "emea",
  mx: "latam",
  my: "apac",
  mz: "emea",
  na: "emea",
  nc: "emea",
  ne: "emea",
  nf: "apac",
  ng: "emea",
  ni: "latam",
  nl: "emea",
  no: "emea",
  np: "apac",
  nr: "apac",
  nu: "apac",
  nz: "apac",
  om: "emea",
  pa: "latam",
  pe: "latam",
  pf: "emea",
  pg: "apac",
  ph: "apac",
  pk: "apac",
  pl: "emea",
  pm: "emea",
  pn: "apac",
  pr: "latam",
  ps: "emea",
  pt: "emea",
  pw: "apac",
  py: "latam",
  qa: "emea",
  re: "emea",
  ro: "emea",
  rs: "emea",
  ru: "emea",
  rw: "emea",
  sa: "emea",
  sb: "apac",
  sc: "emea",
  sd: "emea",
  se: "emea",
  sg: "apac",
  sh: "emea",
  si: "emea",
  sj: "emea",
  sk: "emea",
  sl: "emea",
  sm: "emea",
  sn: "emea",
  so: "emea",
  sr: "latam",
  ss: "emea",
  st: "emea",
  sv: "latam",
  sx: "emea",
  sy: "emea",
  sz: "emea",
  tc: "latam",
  td: "emea",
  tf: "emea",
  tg: "emea",
  th: "apac",
  tj: "emea",
  tk: "apac",
  tl: "apac",
  tm: "emea",
  tn: "emea",
  to: "apac",
  tr: "emea",
  tt: "latam",
  tv: "apac",
  tw: "apac",
  tz: "emea",
  ua: "emea",
  ug: "emea",
  um: "apac",
  us: "na",
  uy: "latam",
  uz: "emea",
  va: "emea",
  vc: "latam",
  ve: "latam",
  vg: "latam",
  vi: "latam",
  vn: "apac",
  vu: "apac",
  wf: "emea",
  ws: "apac",
  ye: "emea",
  yt: "emea",
  za: "emea",
  zm: "emea",
  zw: "emea",
} as const;

type Region = (typeof regionPerCountry)[keyof typeof regionPerCountry];

export const getRegionByCountryCode = (countryCode: string): Region | null => {
  const formattedCode = countryCode.toLowerCase();
  return (
    regionPerCountry[formattedCode as keyof typeof regionPerCountry] || null
  );
};
